import React, { Fragment, useEffect, useRef, useState } from 'react'
import { ErrorMessage, Field } from 'formik';
import classNames from 'classnames';
import "./styles/MultiSelect.scss";
import MultiSelectOption from './components/MultiSelectOption';
import MultiSelectOptions from './components/MultiSelectOptions';
import useClickOutside from 'scenes/ProjectMultiStepForm/hooks/useClickOutside';

const MultiSelect = ({
  config,
  className,
  isOnlyOneOption = false,
  updateField,
  onFilterChange,
}) => {
  const { name, initialValues, selectValues, disabled, disabledPlaceholder, placeholderMessage } = config;
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState(initialValues);
  const { elementRef } = useClickOutside(setShowDropdown);

  const handleShowDropdown = () => {
    if (!disabled) setShowDropdown(true);
  };

  const handleClickCurrentOption = (clickedOption) => (e) => {
    e.stopPropagation();
    
    /* Only one option */
    if (isOnlyOneOption) {
      setSelectedOptions([clickedOption]);
      updateField(name, [clickedOption]);
      return;
    }

    let updatedOptions;
    if (selectedOptions && selectedOptions?.some(option => option.label === clickedOption.label)) {
      updatedOptions = selectedOptions.filter(option => option.label !== clickedOption.label);
    } else {
      updatedOptions = [...selectedOptions, clickedOption];
    }
    
    setSelectedOptions(updatedOptions);
    updateField(name, updatedOptions);
  };

  const handleDeleteOption = (clickedOption) => (e) => {
    e.stopPropagation();

    /* Only one option */
    if (isOnlyOneOption) {
      setSelectedOptions([]);
      updateField(name, []);
      return;
    }

    const optionsWithoutSelectedOption = selectedOptions.filter(
      (option) => option.label !== clickedOption.label
    );
    setSelectedOptions(optionsWithoutSelectedOption);
    updateField(name, optionsWithoutSelectedOption.length > 0 ? optionsWithoutSelectedOption : "");
  }

  useEffect(() => {
    setSelectedOptions(initialValues);
  }, [initialValues]);
  
  return (
    <Fragment>
      <div
        ref={elementRef}
        className={classNames({
          "bg-transparent": !disabled,
          "disabled-select": disabled,
          "custom-select multi-select form-control position-relative": true,
          "h-auto": selectedOptions?.length > 0,
          [className]: true,
        })}
        onClick={handleShowDropdown}
      >
        <div className="multi-select__default-option-products d-flex flex-column">
          {selectedOptions?.length > 0 ? (
            selectedOptions.map((option, index) => (
              <MultiSelectOption
                key={index}
                currentOption={option}
                handleClickInDeleteOption={handleDeleteOption}
              />
            ))
          ) : (
            <span className="multi-select__placeholder">
              {disabled
                ? disabledPlaceholder
                : placeholderMessage} 
            </span>
          )}
        </div>
        <div className='position-relative'>
          {showDropdown && selectValues && (
            <MultiSelectOptions
              selectedOptions={selectedOptions}
              selectValues={selectValues}
              loading={disabled}
              disabledPlaceholder={disabledPlaceholder}
              handleClickCurrentOption={handleClickCurrentOption}
              onFilterChange={onFilterChange}
            />
          )}
        </div>
        <Field
          id={name}
          name={name}
          component="select"
          className="select--field"
          />
      </div>
      <ErrorMessage
        className="form-error-message"
        component="div"
        name={name}
      />
    </Fragment>
  );
}

MultiSelect.defaultProps = {
  config: {
    name: "",
    initialValues: [],
    selectValues: [],
    disabled: false,
    placeholderMessage: "",
  },
  isOnlyOneOption: false,
  updateField: () => {},
  onFilterChange: () => {},
}

export default MultiSelect;